module.exports = __webpack_public_path__ + "img/mv4.0aca9bf9.png";